module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[57]422.42e11d3.woff2";